import { EnvironmentConfigType as OfflineMfeEnvironmentConfigType } from "@WahooFitness/wahoo-offline-mfe";
import { lobbyDefaultRemoteConfig as defaultRemoteConfig } from "@/services/LobbyDefaultRemoteConfig";

type EnvironmentConfigType = OfflineMfeEnvironmentConfigType & {
  mapboxToken: string;
};

type CloudConfigType = {
  wahooCloudRestUrl: string;
  fayeServerUrl: string;
  wahooMyAccountUrl: string;
  wahooLinksUrl: string;
  outOfTheBoxUrl: string;
};

const stagingEnvironment: EnvironmentConfigType = {
  cloudConfig: {
    wahooCloudRestUrl: "https://staging.wahooligan.com",
    fayeServerUrl: "https://mb.staging.wahooligan.com/faye",
    wahooMyAccountUrl: "https://accounts.staging.wahooligan.com",
    wahooLinksUrl: "https://link.staging.wahoofitness.com",
    outOfTheBoxUrl: "https://setup.staging.wahooligan.com",
  },
  firebaseConfig: {
    apiKey: "AIzaSyAMFAbj80_TcKJRpFlK-GL_MrXisdhzt20",
    authDomain: "lobby-81e87.firebaseapp.com",
    projectId: "lobby-81e87",
    storageBucket: "lobby-81e87.appspot.com",
    messagingSenderId: "419280816339",
    appId: "1:419280816339:web:4053b6aad94d02b7fe6c26",
    measurementId: "G-DGR9H2PSY3",
  },
  fallbackAppId: 1387,
  componentId: 4,
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN,
  appVersion: LOBBY_MFE_VERSION,
  defaultRemoteConfig,
  bugsnagApiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
};

const productionEnvironment: EnvironmentConfigType = {
  cloudConfig: {
    wahooCloudRestUrl: "https://www.wahooligan.com",
    fayeServerUrl: "https://mb.wahooligan.com/faye",
    wahooMyAccountUrl: "https://accounts.wahooligan.com",
    wahooLinksUrl: "https://link.wahoofitness.com",
    outOfTheBoxUrl: "https://setup.wahoofitness.com",
  },
  firebaseConfig: {
    apiKey: "AIzaSyAMFAbj80_TcKJRpFlK-GL_MrXisdhzt20",
    authDomain: "lobby-81e87.firebaseapp.com",
    projectId: "lobby-81e87",
    storageBucket: "lobby-81e87.appspot.com",
    messagingSenderId: "419280816339",
    appId: "1:419280816339:web:729c85eefe935866fe6c26",
    measurementId: "G-5HV52NK699",
  },
  fallbackAppId: 1387,
  componentId: 4,
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN,
  appVersion: LOBBY_MFE_VERSION,
  defaultRemoteConfig,
  bugsnagApiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
};

const getEnvironmentConfig = (
  environment: "staging" | "production" | undefined
): EnvironmentConfigType => {
  if (environment === "production") {
    return productionEnvironment;
  }
  return stagingEnvironment;
};

export { getEnvironmentConfig };
export type { CloudConfigType };
